<template>
    <div>
      <div v-if="currentMenuHijo == 'S' + category.category_father">
          <b-list-group-item @click="currentMenuHijo = mapMenu[mapMenu.length -2]" v-if="indice == 0"
              href="#"
              class="d-flex justify-content-between align-items-center text-white">
              <div>
                  <h5> 
                      <b-icon icon="caret-left-fill" class="mr-2"></b-icon>
                      Volver
                  </h5>
              </div>
          </b-list-group-item>
          <b-list-group-item :to="{name: 'listadoInventario', params:{ categoryCode: category.category_code, slug: category.slug, categoria: category.name}}"
              class="d-flex justify-content-between align-items-center text-white">
              <div>
                  <h5>
                  {{category.name}}
                  </h5>
              </div>
              <b-icon icon="caret-down-fill" style="cursor: pointer"  
              @click="currentMenuHijo = 'S' + category.category_code" v-if="category.sub_categories.length"></b-icon>
          </b-list-group-item>
      </div>
      <supplierCategories v-for="(category, index) in category.sub_categories" :key="index" :indice="index" :mapMenu="mapMenu" :category="category" v-model="currentMenuHijo"/>
    </div>
  </template>
  
  <script>
  export default {
    name: "supplierCategories",
    props: ["category", "value", "indice", "mapMenu"],
    computed: {
      currentMenuHijo: {
        get() {
          return this.value;
        },
        set(value) {
            this.$emit("input", value);
        }
      }
    },
    data() {
      return {
      };
    },
    created() {
    },
  };
  </script>
  
  <style scoped>
  .list-group-item {
      background-color: #343a40;
  }
  
  .list-group-item:hover {
      background-color: #535e69;
  }
  
  .list-group-item.active, .list-group-item.active:hover, .list-group-item.active:focus {
      background-color: #535e69 !important;
  }
  </style>